import { loginObj } from '@/services/base';
import axios from 'axios';
import setupInterceptors from '@/services/setupInterceptors';
import tasks from '@/js/tasks';
var configuration = JSON.parse(process.env.VUE_APP_API_GTW_CONFIG);
var appApisGTW = null;
if (!configuration['data_quality']) {
  appApisGTW = axios.create({
    baseURL: 'http://localhost{PORT}'.replace('{PORT}', ':5000')
  });
} else {
  appApisGTW = axios.create({
    baseURL: process.env.VUE_APP_API_GTW.replace('{PORT}', ':8091')
  });
}
setupInterceptors(appApisGTW);
var headers = {
  'Content-Type': 'application/json'
};
var CONTROLLER_NAME = '/data_quality';
var DOMAIN_SCORE = '/profiling_score';
var FIELD_TYPE = '/field_type';
var TABLE_RULE = '/table_rule';
export default {
  getProfilingScoreFieldTypes: function getProfilingScoreFieldTypes() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    tasks.lockScreen.lock();
    return appApisGTW.get("".concat(CONTROLLER_NAME).concat(DOMAIN_SCORE).concat(FIELD_TYPE, "/get_all"), {
      headers: headers
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    }).catch(function (error) {
      console.error(error);
    });
  },
  getProfilingScoreTableRule: function getProfilingScoreTableRule() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    tasks.lockScreen.lock();
    return appApisGTW.get("".concat(CONTROLLER_NAME).concat(DOMAIN_SCORE).concat(TABLE_RULE, "/get_all"), {
      headers: headers
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    }).catch(function (error) {
      console.error(error);
    });
  },
  postScoreParam: function postScoreParam(scorePath) {
    var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var login = loginObj();
    var body = {
      login: login,
      values: values
    };
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(scorePath), body, {
      headers: headers
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    }).catch(function (error) {
      console.error(error);
    });
  },
  putScoreParam: function putScoreParam(scorePath, documentId) {
    var values = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var oldValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var login = loginObj();
    var body = {
      login: login,
      values: values,
      oldValues: oldValues
    };
    tasks.lockScreen.lock();
    return appApisGTW.put("".concat(CONTROLLER_NAME).concat(scorePath, "/").concat(documentId), body, {
      headers: headers
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    }).catch(function (error) {
      console.error(error);
    });
  },
  deleteScoreParam: function deleteScoreParam(scorePath, documentId, domain) {
    var params = {
      domain: domain
    };
    tasks.lockScreen.lock();
    return appApisGTW.delete("".concat(CONTROLLER_NAME).concat(scorePath, "/").concat(documentId), {
      params: params,
      headers: headers
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    }).catch(function (error) {
      console.error(error);
    });
  }
};